import { render, staticRenderFns } from "./BusinessFrontPageOpeningHoursSummaryCard.vue?vue&type=template&id=6f18a4b2&scoped=true&"
import script from "./BusinessFrontPageOpeningHoursSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./BusinessFrontPageOpeningHoursSummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessFrontPageOpeningHoursSummaryCard.vue?vue&type=style&index=0&id=6f18a4b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f18a4b2",
  null
  
)

export default component.exports